import Vue from 'vue'
import VueMeta from 'vue-meta'

export function initialiseVueMeta () {
  Vue.use(VueMeta)
}
